export class MemoryTokenStore {
  constructor() { this.token = null; }
  get() { return this.token; }
  set(token) { this.token = token || null; }
  clear() { this.token = null; }
}